const escape = (content) => {
  const div = document.createElement("div");
  div.textContent = content;
  return div.innerHTML;
};

export const defaults = {
  delay: 750,
  clearButton: false,
  howManyCharacters: 3,

  onResults: ({ currentValue, matches, template, classGroup }) => {
    if (matches === 0) {
      return template;
    }

    const regex = new RegExp(currentValue, "gi");

    return matches
      .map((result) => {
        return `
              <li class="[&.auto-selected]:bg-teal [&.auto-selected]:text-white">
                <span class="hidden">${result.place_name}</span>
                <div class="flex items-center justify-between gap-2 w-full px-4 py-3 cursor-pointer text-gray-600 [.auto-selected_&]:text-white">
                  <div>
                    <div class="truncate">${escape(result.place_name).replace(regex, (str) => `<mark>${str}</mark>`)}</div>
                    ${result.type === "region" ? `<div class="text-sm">Region</div>` : ""}
                  </div>
                </div>
              </li>
            `;
      })
      .join("");
  },

  noResults: ({ currentValue, template }) => {
    return template(
      `<div class="px-4 py-2 text-gray-600">No locations match your query.</div>`,
    );
  },
};
